export const getMiniStoryboardSourcePageKey = (segment) => {
  if (!segment) return "";
  if (segment.id != null) return `id:${segment.id}`;
  const index = Number(segment.segmentIndex);
  return Number.isFinite(index) && index > 0 ? `index:${index}` : "";
};

export const resolveMiniStoryboardSourcePage = (segments, selectedSegment, requestedKey) => {
  const pages = Array.isArray(segments) ? segments : [];
  if (!pages.length) return { segment: null, index: -1, total: 0, key: "" };

  const selectedKey = getMiniStoryboardSourcePageKey(selectedSegment);
  let index = requestedKey
    ? pages.findIndex((segment) => getMiniStoryboardSourcePageKey(segment) === requestedKey)
    : -1;
  if (index < 0 && selectedKey) {
    index = pages.findIndex((segment) => getMiniStoryboardSourcePageKey(segment) === selectedKey);
  }
  if (index < 0) index = 0;

  const segment = pages[index];
  return { segment, index, total: pages.length, key: getMiniStoryboardSourcePageKey(segment) };
};
